import SB from '.';
import { unreachable } from '../utils/Utils';

export function* iterateSchema(schema: SB.Schema, path = ''): Generator<[string, SB.Schema]> {
    yield [path, schema];

    switch (schema._type) {
        case 'boolean':
        case 'integer':
        case 'null':
        case 'number':
        case 'string':
        case 'tuple':
        case 'unknown': {
            return;
        }

        case 'array': {
            if (!schema.isArraySchema()) {
                throw Error(`Unexpected array schema: ${JSON.stringify(schema)}`);
            }

            const itemSchema = schema.getItemSchema();

            return yield* iterateSchema(itemSchema, `${path}[]`);
        }

        case 'map': {
            const itemSchema = (schema as unknown as SB.MapSchema<any>).getItemSchema();

            return yield* iterateSchema(itemSchema, `${path}.*`);
        }

        case 'object': {
            if (!schema.isObjectSchema()) {
                throw Error(`Unexpected object schema: ${JSON.stringify(schema)}`);
            }

            const propertySchemas = schema.getFullSchema() as Record<string, SB.Schema>;

            for (const key in propertySchemas) {
                const propertySchema = propertySchemas[key]!;

                yield* iterateSchema(propertySchema, `${path}.${key}`);
            }

            const additionalPropertiesSchema = schema.getAdditionalPropertyValuesSchema();
            if (additionalPropertiesSchema) {
                yield* iterateSchema(additionalPropertiesSchema, `${path}.*`);
            }

            break;
        }

        case 'union': {
            const itemSchemas = (schema as unknown as SB.UnionSchema<any>).getItemSchemas();

            for (let i = 0; i < itemSchemas.length; i++) {
                const itemSchema = itemSchemas[i]!;

                yield* iterateSchema(itemSchema, `${path}[${i}]`);
            }
            break;
        }

        default:
            unreachable(schema._type);
    }
}
